import { render, staticRenderFns } from "./OrderCompleted.vue?vue&type=template&id=48a5f313&"
import script from "./OrderCompleted.vue?vue&type=script&lang=ts&"
export * from "./OrderCompleted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports